module.exports = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6 19h12v2H6z"/><path fill="none" d="M0 0h24v24H0V0z"/></svg>'